export default function ContactMe(){
    return (
        <section id="contact" className="contact--section">
            <div>
                <h2 className="section-heading">Contact Me</h2>
                <div>
                    <div className="header-bar"></div>
                </div>
            </div>
            <form className="contact--form--container" action="https://api.web3forms.com/submit" method="post">
                <input type="hidden" name="access_key" value="9fb46ae1-9870-4cf6-b469-f3857a88f589" />
                <div className="form-container">
                    <label htmlFor="first-name" className="contact--label">
                        <span className="text-md">First Name</span>
                        <input type="text" className="contact--input text-md" name="first-name" id="first-name" required/>
                    </label>
                    <label htmlFor="last-name" className="contact--label">
                        <span className="text-md">Last Name</span>
                        <input type="text" className="contact--input text-md" name="last-name" id="last-name" required/>
                    </label>
                    <label htmlFor="email" className="contact--label">
                        <span className="text-md">Email</span>
                        <input type="email" className="contact--input text-md" name="email" id="email" required/>
                    </label>
                    <label htmlFor="phone-number" className="contact--label">
                        <span className="text-md">Phone Number</span>
                        <input type="text" className="contact--input text-md" name="phone-number" id="phone-number" required/>
                    </label>
                </div>
                <div>
                    <label htmlFor="message" className="contact--label">
                        <span className="text-md">Message</span>
                        <textarea className="contact--input text-md" name="message" id="message" rows="8" placeholder="Type your message" required/> 
                    </label>
                </div>
                <div>
                    <button type="submit" className="btn btn-primary contact--form-btn">Submit</button>
                </div>
            </form>
        </section>
    )
}